/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/extensions */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    userData: null,
    loading: false,
    errorLogin: '',
    success: false,
    errorReset: '',
    resetPassword: undefined,
    compliancePopup: {},
    complianceId: 0,
};
var userAuthSlice = createSlice({
    name: 'login',
    initialState: initialState,
    reducers: {
        loginUser: function (state, action) {
            state.loading = true;
            state.errorLogin = '';
            state.userData = null;
        },
        loginUserLoaded: function (state, action) {
            var _a;
            var user = action.payload;
            state.userData = user;
            state.loading = false;
            state.complianceId = (_a = user === null || user === void 0 ? void 0 : user.userCompliancePopup) === null || _a === void 0 ? void 0 : _a.complianceId;
        },
        loginError: function (state, action) {
            state.errorLogin = action.payload;
            state.loading = false;
        },
        forgetPassword: function (state, action) {
            state.loading = true;
            state.success = false;
        },
        forgetPasswordLoaded: function (state, action) {
            state.loading = false;
            state.success = action.payload;
        },
        resetForgetPassword: function (state, action) {
            state.success = action.payload;
            state.errorReset = '';
        },
        resetPassword: function (state, action) {
            state.resetPassword = {
                loading: true,
                loaded: false,
                errorMessage: '',
                success: false,
                error: false,
            };
        },
        resetPasswordLoaded: function (state, action) {
            state.resetPassword = {
                loading: false,
                loaded: true,
                errorMessage: '',
                success: true,
                error: false,
            };
        },
        resetPasswordError: function (state, action) {
            state.resetPassword = {
                loading: false,
                loaded: true,
                errorMessage: action.payload,
                success: false,
                error: true,
            };
        },
        resetResetPassword: function (state, action) {
            state.resetPassword = undefined;
        },
        getUserProfile: function (state, action) {
            state.loading = true;
            state.errorLogin = '';
            state.userData = null;
        },
        setCompliancePopup: function (state, action) {
            state.compliancePopup = action.payload;
        },
    },
});
export var actions = userAuthSlice.actions, reducer = userAuthSlice.reducer, sliceKey = userAuthSlice.name;
